import React, { useState } from 'react';
import { Container, Row, Col, Form } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import GenericMessage from 'src/Components/GenericMessage/GenericMessage';
import GenericButton from '../../../../../Components/GenericButton/GenericButton';
import './enrollmentcoverageflow.scss';
import DatePicker from '../../../common/DatePicker';

const EffectiveDate = ({
  nextStep,
  prevStep,
  enrollmentFormData,
  setEnrollmentFormData,
  contentData,
  currentStep,
}) => {
  const { Default_Time_Format } = useSelector(
    ({ app }) => app.appConfigs.Time_Setting || 'MM-dd-yyyy',
  );
  const navigate = useNavigate();
  console.log('enrollmentFormData', enrollmentFormData);
  const [childDOBAdoptionDate, setChildDOBAdoptionDate] = useState(
    enrollmentFormData?.adoptionOrBirthDate || '',
  );
  console.log('childDOBAdoptionDate', childDOBAdoptionDate);

  return (
    <div className="new-child-born-or-adoption">
      <div className="new-child-born-or-adoption-header">
        <div>{contentData && contentData?.Title ? contentData?.Title : ''}</div>
      </div>
      <div className="new-child-born-or-adoption-content">
        {contentData &&
          contentData?.Greetings &&
          contentData?.Greetings !== '' && <p>{contentData?.Greetings}</p>}
        <p>
          Your employer may require you to provide documentation regarding the
          date of your status change. Intentionally providing false information
          may be considered grounds for termination or other legal action.
        </p>
        <p>Before you proceed, please confirm:</p>
        <ul>
          <li>
            {`The information you're about to provide is true and correct.`}
          </li>
          <li>{`You've read the life event information in the plan document.`}</li>
          <li>
            You understand that any fraudulent statement, falsification, or
            material omission of information may subject you to discipline up to
            and including termination of employment.
          </li>
        </ul>
        <Row className="mt-4 effective-date-item">
          <Col md={6} lg={6} sm={6}>
            <Form.Group controlId="formBasicdob">
              <Form.Label className="dob-label">
                {contentData && contentData?.Label ? contentData?.Label : ''}
                <span aria-hidden={true} className="mandatory-field">
                  *
                </span>
              </Form.Label>
              {/*<Form.Control
                type="date"
                name="DOB"
                placeholder="MM/DD/YYYY"
                className=""
                value={childDOBAdoptionDate || ''}
                //max={new Date().toISOString().split('T')[0]}
                //onChange={handleChange}
                //onBlur={handleBlur}
                //isInvalid={touched.DOB && errors.DOB}
                autoCorrect="off"
                spellCheck="off"
                autoFocus={false}
                autoComplete="off"
                onChange={(e) => {
                  setChildDOBAdoptionDate(e.target.value);
                }}
              /> */}

              <DatePicker
                name={'DOB'}
                showIcon={true}
                isDOB={true}
                value={childDOBAdoptionDate || ''}
                allowFutureDates={true}
                onChange={(date) => setChildDOBAdoptionDate(date)}
              />

              <Form.Control.Feedback type="invalid">
                <span role="alert"></span>
              </Form.Control.Feedback>
            </Form.Group>
          </Col>
        </Row>
        <div>
          <GenericMessage
            wrapperClasses="mt-4 mb-5 msg-txt"
            boldMessage="Important:"
            message="You will have 31 days from the actual event date to make benefits changes."
            messageType={'info'}
            showMessage={true}
            hideCloseButton={true}
          />
        </div>
        <div>
          <Form.Group className="form-block" controlId="buttonsFormGroup">
            <Row>
              <Col className="d-flex justify-content-end">
                <GenericButton
                  variant="link"
                  onClick={() => {
                    if (currentStep === 1) {
                      navigate({ pathname: '/admin/enrollment-life-event' });
                    } else {
                      prevStep();
                    }
                  }}
                  className="form-btn"
                >
                  Back
                </GenericButton>
                <GenericButton
                  type="button"
                  className="mr-0"
                  disable={!childDOBAdoptionDate}
                  buttonDisabled={!childDOBAdoptionDate}
                  //disable={true}
                  //buttonDisabled={true}
                  onClick={() => {
                    nextStep();
                    setEnrollmentFormData({
                      ...enrollmentFormData,
                      adoptionOrBirthDate: childDOBAdoptionDate,
                    });
                  }}
                >
                  Continue
                </GenericButton>
              </Col>
            </Row>
          </Form.Group>
        </div>
      </div>
    </div>
  );
};

export default EffectiveDate;
